import { Popper, PopperProps } from '@mui/material';
import { Info } from 'lucide-react';
import { ReactNode } from 'react';
import { CueBubble, getCuePopperSx } from './cue.styles';

const CUE_MODIFIERS = [{ name: 'offset', options: { offset: [0, 10] } }];

export interface CueProps extends Omit<PopperProps, 'children' | 'modifiers' | 'sx'> {
  children: ReactNode;
  'data-testid'?: string;
}

/** A pill callout pointing at an element, announcing a one-off change. Never interactive. */
export const Cue = ({
  children,
  placement = 'bottom',
  'data-testid': testId,
  ...popperProps
}: CueProps) => (
  <Popper placement={placement} modifiers={CUE_MODIFIERS} sx={getCuePopperSx} {...popperProps}>
    <CueBubble role="status" data-testid={testId}>
      <Info size={14} />
      {children}
    </CueBubble>
  </Popper>
);
